import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { saveToken } from "./tokenService";
import { setUserLocalData } from "./userService";

export const loginUser = (data) => {
  return axios.post("/api/auth/agent/login", data);
};

export const useLogin = () => {
  // const { updateUser } = useUpdateUser();
  // const { addNotification } = useNotificationStore();
  const navigate = useNavigate();

  return useMutation(loginUser, {
    onSuccess: (res) => {
      if (res?.data?.access_token) {
        console.log("useMutation ===> ", res);
        const role = res.data.user.roles[0].name;
        saveToken(res.data.access_token, res.data.expires_in);
        setUserLocalData(res.data.user);
        (role === "chat-admin") &&
          navigate("/mainView/stock");
        role === "quality-assurance" && navigate("/mainView/past-chat");
        role === "agent" && navigate("/agentView");
        // storage.setToken(data.data.token, "");
        // updateUser();
      } else {
        navigate("/");
        // addNotification({
        //   message:
        //     "Please confirm you email. We have sent an email with a confirmation link to your email address.",
        //   type: "info",
        // });
      }
    },
    onError: (error) => {
      if (error.response?.data?.message)
        console.log(error.response?.data?.message);
      // addNotification({
      //   message: error.response?.data?.message,
      //   type: "warning",
      // });
    },
    // onSettled: () => {
    //   queryClient.invalidateQueries("user");
    // },
  });
};
